export default __webpack_public_path__ + "static/media/Generar OC.38d0dcdf.png";